import type { FieldValidationError } from '@atlassian/jira-fetch/src/utils';
import type { EditableComponent, CreatedComponent } from '../../common/model/types';
import type { Props } from '../model/types';

// SET APP PROPS
export const SET_APP_PROPS = 'state.SET_APP_PROPS' as const;
export type SetAppPropsAction = {
	type: typeof SET_APP_PROPS;
	payload: Props;
};
export const setAppProps = (payload: Props): SetAppPropsAction => ({
	type: SET_APP_PROPS,
	payload,
});

// SAVE
export const SAVE = 'state.SAVE' as const;
export type SaveAction = {
	type: typeof SAVE;
};
export const save = (): SaveAction => ({
	type: SAVE,
});

// CANCEL
export const CANCEL = 'state.CANCEL' as const;
export type CancelAction = {
	type: typeof CANCEL;
};
export const cancel = (): CancelAction => ({
	type: CANCEL,
});

// UPDATE
export const UPDATE = 'state.UPDATE' as const;
export type UpdatePayload = EditableComponent;
export type UpdateAction = {
	type: typeof UPDATE;
	payload: UpdatePayload;
};
export const update = (payload: UpdatePayload): UpdateAction => ({
	type: UPDATE,
	payload,
});

// SUCCESS
export const SUCCESS = 'state.SUCCESS' as const;
export type SuccessPayload = CreatedComponent;
export type SuccessAction = {
	type: typeof SUCCESS;
	payload: SuccessPayload;
};
export const success = (payload: SuccessPayload): SuccessAction => ({
	type: SUCCESS,
	payload,
});

// VALIDATION FAILURE
export const VALIDATION_FAILURE = 'state.VALIDATION_FAILURE' as const;
export type ValidationFailurePayload = FieldValidationError[];
export type ValidationFailureAction = {
	type: typeof VALIDATION_FAILURE;
	payload: ValidationFailurePayload;
};
export const validationFailure = (payload: ValidationFailurePayload): ValidationFailureAction => ({
	type: VALIDATION_FAILURE,
	payload,
});

// FAILURE
export const FAILURE = 'state.FAILURE' as const;
export type FailureAction = {
	type: typeof FAILURE;
};
export const failure = (): FailureAction => ({
	type: FAILURE,
});

export type Action =
	| SetAppPropsAction
	| SaveAction
	| CancelAction
	| UpdateAction
	| SuccessAction
	| ValidationFailureAction
	| FailureAction;
